"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFilterDisplayForm = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
function validateFilterDisplayForm(ctx, filterAttribute, displayForm) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, attributeDisplayForms;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // validate if the filter attribute is available
                    if (!filterAttribute) {
                        return [2 /*return*/, "INVALID_FILTER_ATTRIBUTE"];
                    }
                    backend = ctx.backend, workspace = ctx.workspace;
                    return [4 /*yield*/, backend.workspace(workspace).attributes().getAttribute(filterAttribute)];
                case 1:
                    attributeDisplayForms = (_a.sent()).displayForms;
                    // validate if the display form is between attributes available display forms.
                    // try matching both uri and id in case the type of ref is different from what is in the ref field
                    if (attributeDisplayForms.some(function (df) {
                        return sdk_model_1.areObjRefsEqual(sdk_model_1.idRef(df.id, "displayForm"), displayForm) ||
                            sdk_model_1.areObjRefsEqual(sdk_model_1.uriRef(df.uri), displayForm);
                    })) {
                        return [2 /*return*/, "VALID"];
                    }
                    return [2 /*return*/, "INVALID_ATTRIBUTE_DISPLAY_FORM"];
            }
        });
    });
}
exports.validateFilterDisplayForm = validateFilterDisplayForm;
//# sourceMappingURL=filterDisplayFormValidation.js.map